var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Children } from 'react';
import { ChoicesContextProvider, ResourceContextProvider, } from 'react-admin';
import { useReferenceManyToManyInputController, } from './useReferenceManyToManyInputController';
import { UsingRegexp } from './constants';
/**
 * Allows to edit reference records through a relations table.
 *
 * You must define the fields to be passed to the iterator component as children.
 *
 * @example Allowing to pick the tags of a post using a SelectArrayInput
 *  <ReferenceManyToManyInput
 *      label="Posts"
 *      reference="posts"
 *      through="posts_tags"
 *      using="tag_id,post_id"
 *  >
 *      <SelectArrayInput optionText="name" />
 *  </ReferenceManyToManyInput>
 *
 * @example Allowing to pick the tags of a post using a CheckboxGroupInput
 *  <ReferenceManyToManyInput
 *      label="Posts"
 *      reference="posts"
 *      through="posts_tags"
 *      using"tag_id,post_id"
 *  >
 *      <CheckboxGroupInput optionText="name" />
 *  </ReferenceManyToManyInput>
 */
export var ReferenceManyToManyInput = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    if (!props.using.match(UsingRegexp)) {
        throw new Error('<ReferenceManyToManyInput> incorrect `using` props format. `using` should be a string of two fields separated by a comma such as `book_id,author_id`');
    }
    if (Children.count(children) !== 1) {
        throw new Error('<ReferenceManyToManyInput> only accepts a single child');
    }
    var controllerProps = useReferenceManyToManyInputController(props);
    return (React.createElement(ResourceContextProvider, { value: controllerProps.resource },
        React.createElement(ChoicesContextProvider, { value: controllerProps }, children)));
};
ReferenceManyToManyInput.defaultProps = {
    sort: {
        field: 'id',
        order: 'DESC',
    },
};
